module.exports = __webpack_public_path__ + "i18n/ko.424502101ff98085015ab7c6fa6dfae8.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1061
// module chunks = 60